import React from 'react';

import { Stack, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckpointSelect from '@/components/shared/CheckpointSelect';

export default function CheckpointField({
  index,
  value,
  error,
  setValue,
  setError,
  remove,
}) {
  const handleChange = (next) => {
    setValue(index, {
      public: next.public,
      id: next.id,
      as: next.as,
    });
  };

  return (
    <Stack
      direction='row'
      justifyContent='flex-start'
      alignItems='center'
      spacing={1}
    >
      <CheckpointSelect
        value={value}
        onChange={handleChange}
        error={error}
        onError={(err) => setError(index, err)}
        required
        field_id={`checkpoint-${index}`}
      />
      <IconButton
        onClick={() => {
          remove(index);
        }}
      >
        <DeleteIcon />
      </IconButton>
    </Stack>
  );
}
